import ConnectShopToProceedModal from './ConnectShopToProceedModal.vue';

export default ConnectShopToProceedModal;
